//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations, mapState, mapActions } from 'vuex';
import countryList from './countries';
import * as gapi from '~/api/g-init';
import * as userApi from '~/api/user';
import * as types from '~/types';
import { reloadRoute } from '~/utils';
export default {
  data() {
    return {
      tab: 'phone',
      userInput: {
        countryCode: '86',
        phoneCode: '',
        phone: '',
        account: '',
        password: '',
        passwordConfirm: '',
      },
      timer: {
        phone: {
          createdAt: 0,
          id: null,
          cd: 0,
        },
        forget: {
          createdAt: 0,
          id: null,
          cd: 0,
        },
      },
      errorMsg: '', // 错误消息
      errorType: '', // 错误类型
      agree: false,
      showTip: false,
    };
  },
  computed: {
    ...mapState('user', ['isLoginFormShow', 'isRegistFirst']),
    /**
     * @description 电话号码国号
     * @returns { Array } 列表
     */
    countries() {
      return countryList;
    },
    /**
     * @description 按钮文案
     * @returns { string } 按钮文案
     */
    submitText() {
      if (['phone', 'password'].includes(this.tab)) {
        return this.$t('login.submit.login');
      } else if (this.tab === 'forget') {
        return this.$t('login.submit.commit');
      }
      return this.$t('login.submit.login');
    },
  },
  beforeDestroy() {
    this.initData();
  },
  methods: {
    ...mapMutations('user', {
      signIn: types.USER_SIGNIN,
      hide: types.HIDE_LOGIN_FORM,
    }),
    ...mapActions('user', {
      loginLocal: types.LOGIN_LOCAL,
      getFollows: types.GET_FOLLOWS,
      getStockFollows: types.GET_STOCK_FOCUS,
    }),
    ...mapActions({
      updateVipMemberInfo: 'user/updateVipMemberInfo',
    }),
    /**
     * @description 初始化数据
     */
    initData() {
      this.tab = 'phone';
      this.userInput = {
        countryCode: '86',
        phoneCode: '',
        phone: '',
        account: '',
        password: '',
      };
      this.errorMsg = '';
      this.errorType = '';
    },
    /**
     * @description 第一次登录的用户需要调用一次同意用户合同操作
     */
    async agreeAgreement() {
      try {
        await this.$axios(userApi.agreeAgreement());
      } catch (e) {}
    },
    /**
     * @description 修改切换头部
     * @param { string } type 类型
     */
    changeTab(type) {
      if (type === this.tab) return;
      this.userInput = {
        countryCode: '86',
        phoneCode: '',
        phone: '',
        account: '',
        password: '',
      };
      this.errorMsg = '';
      this.errorType = '';
      this.tab = type;
      this.showTip = false;
    },
    /**
     * @description 验证码冷却计时器入口
     * @param { string } type 类型
     */
    startTick(type) {
      this.timer[type].id = setInterval(() => {
        this.timerTick(type);
      }, 1000);
      this.timer[type].createdAt = Date.now();
    },
    /**
     * @description 验证码冷却计时器的step函数
     * @param { string } type 类型
     */
    timerTick(type) {
      const val = Math.floor((Date.now() - this.timer[type].createdAt) / 1000);
      this.timer[type].cd = Math.max(60 - val, 0);
      if (this.timer[type].cd === 0) {
        clearInterval(this.timer[type].id);
        this.timer[type].createdAt = 0;
      }
    },
    /**
     * @description 获取电话验证码
     */
    async getPhoneCode(
      challenge = undefined,
      validate = undefined,
      seccode = undefined
    ) {
      this.clearErrorMsg();
      const { phone, countryCode } = this.userInput;
      const tab = this.tab;
      if (!phone) {
        this.errorMsg = this.$t('login.error.phone-empty');
        this.errorType = tab;
        return false;
      }
      let pros = null;
      switch (tab) {
        case 'phone': // 验证码登录
        case 'forget': // 忘记密码
          pros = await this.$axios(
            userApi.getFastLoginPhoneCode({
              phone,
              countryCode,
              challenge,
              validate,
              seccode,
            })
          );
          break;
        default:
          break;
      }
      if (!pros) return false;
      if (pros.statusCode === 2000) {
        // 触发了极验
        const GInit = await this.$axios(
          gapi.getGInit({
            phone,
            countryCode,
          })
        ); // 服务端获取极验初始化参数
        if (!GInit.result) return;
        initGeetest(
          {
            gt: GInit.result.gt,
            challenge: GInit.result.challenge,
            offline: !GInit.result.success,
            new_captcha: true,
            width: '100%',
            product: 'bind',
          },
          captchaObj => {
            // 准备好了
            captchaObj.onReady(() => {
              captchaObj.verify();
              captchaObj.onSuccess(() => {
                const result = captchaObj.getValidate();
                challenge = result.geetest_challenge;
                validate = result.geetest_validate;
                seccode = result.geetest_seccode;
                // 带上之前的验证的参数激活getPhoneCode 重新获取验证码
                this.getPhoneCode(challenge, validate, seccode);
              });
            });
          }
        );
      } else if (pros.statusCode === 200) {
        // 获取验证码成功
        this.startTick(tab);
      } else {
        this.errorMsg = pros.message;
        this.errorType = tab;
      }
    },
    /**
     * @description 验证表单
     */
    validateForm() {
      const tab = this.tab;
      if (tab === 'phone') {
        const { phone, phoneCode } = this.userInput;
        if (!phone) {
          this.errorMsg = this.$t('login.error.phone-empty');
          this.errorType = 'phone';
          return false;
        } else if (!phoneCode) {
          this.errorMsg = this.$t('login.error.phone-empty');
          this.errorType = 'phoneCode';
          return false;
        }
      } else if (tab === 'password') {
        const { account, password } = this.userInput;
        if (!account) {
          this.errorMsg = this.$t('login.error.account-empty');
          this.errorType = 'password';
          return false;
        } else if (!password) {
          this.errorMsg = this.$t('login.error.password-empty');
          this.errorType = 'pwd';
          return false;
        }
      } else if (tab === 'forget') {
        const { phone, phoneCode, password, passwordConfirm } = this.userInput;
        if (!phone) {
          this.errorMsg = this.$t('login.error.phone-empty');
          this.errorType = 'forget';
          return false;
        } else if (!phoneCode) {
          this.errorMsg = this.$t('login.error.phone-empty');
          this.errorType = 'phoneCode';
          return false;
        } else if (!password) {
          this.errorMsg = this.$t('login.error.password-empty');
          this.errorType = 'password';
          return false;
        } else if (password.length < 6 || password.length > 16) {
          this.errorMsg = this.$t('login.error.password-length');
          this.errorType = 'password';
          return false;
        } else if (password !== passwordConfirm) {
          this.errorMsg = this.$t('login.error.password-confirm');
          this.errorType = 'passwordConfirm';
          return false;
        }
      }
    },
    /**
     * @description 验证码登录逻辑
     */
    async loginPhone() {
      const { phone, countryCode, phoneCode } = this.userInput;
      const data = await this.$axios(
        userApi.getFastLogin({
          phone,
          phoneCode,
          countryCode,
        })
      );
      if (data.statusCode === 200) {
        this.loginSuccess(data);
      } else {
        this.errorMsg = data.message;
        this.errorType = 'phoneCode';
      }
    },
    /**
     * @description 账号密码登录
     */
    async loginAccount() {
      const { account, password } = this.userInput;
      const data = await this.$axios(
        userApi.loginAccount({
          account,
          password,
        })
      );
      if (data.statusCode === 200) {
        this.loginSuccess(data);
      } else {
        this.errorMsg = data.message;
        this.errorType = 'password';
      }
    },
    /**
     * @description 忘记密码提交
     */
    async forgotPhone() {
      const { phone, phoneCode, password, passwordConfirm, countryCode } =
        this.userInput;
      const data = await this.$axios(
        userApi.resetPasswordPhone({
          phone,
          phoneCode,
          password,
          passwordConfirm,
          countryCode,
        })
      );
      if (data.statusCode === 200) {
        this.$emit('changePage', {
          page: 'pageSuccess',
          type: 'forget',
        });
      } else {
        this.errorMsg = data.message;
        this.errorType = 'phoneCode';
      }
    },
    /**
     * @description 登录成功
     * @param { Object } res 接口回调
     */
    loginSuccess(res) {
      this.signIn(res.result);
      if (res.result) {
        this.updateVipMemberInfo(res.result.vip);
      }
      this.getFollows();
      this.getStockFollows();
      this.hide();
      if (!res.result.agreeUserAgreement) {
        // TODO: 调用同意合同接口
        this.agreeAgreement();
      }
      if (reloadRoute()) {
        // 会员体系相关页面登录后刷新页面
        location.reload();
      }
    },
    /**
     * @description 表单提交逻辑
     */
    submit() {
      this.clearErrorMsg();
      this.validateForm();
      if (this.errorMsg || this.errorType) return false;
      const tab = this.tab;
      if (!this.agree && tab !== 'forget') {
        this.showTip = true;
        return false;
      }
      switch (tab) {
        case 'phone': // 验证码登录
          this.loginPhone();
          break;
        case 'password': // 账号密码登录
          this.loginAccount();
          break;
        case 'forget': // 忘记密码
          this.forgotPhone();
          break;
        default:
          break;
      }
    },
    /**
     * @description 微信登录
     */
    weixinLogin() {
      if (!this.agree) {
        this.showTip = true;
        return false;
      }
      this.$emit('changePage', {
        page: 'weixin',
      });
    },
    /**
     * @description 清楚错误信息
     */
    clearErrorMsg() {
      this.errorMsg = '';
      this.errorType = '';
    },
    /**
     * @description 点击勾选同意协议
     */
    clickAgreeAgreement() {
      this.agree = !this.agree;
      this.showTip = false;
    },
  },
};
